<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_cardsetting_banner.jpg')" alt="出金口座の登録方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <div class="sup-cardsetting-tabs">
          <router-link class="sup-cardsetting-tab sup-cardsetting-tab--active" to="/page/sup-cardsetting-bank">
            銀行口座の登録方法
          </router-link>
          <router-link class="sup-cardsetting-tab" to="/page/sup-cardsetting-ewallet">
            eウォレットアカウントの登録方法
          </router-link>
          <router-link class="sup-cardsetting-tab" to="/page/sup-cardsetting-ewalletid">
            各決済サービスのユーザーIDの確認方法
          </router-link>
        </div>
        <h1 class="sup-page-title">
          銀行口座の登録方法
        </h1>
        <div class="sup-steps-box">
          <!-- ステップ 1 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 1
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ ホーム画面の「詳細」＞「アカウント」をタップ</p>
              <p>➋ 「決済方法」をタップ</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_bank1.jpg')" alt="ステップ1-1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_bank2.jpg')" alt="ステップ1-2">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 2 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 2
            </p>
            <p class="sup-step-desc">
              「口座を追加」をタップ
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_bank3.jpg')" alt="ステップ2">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 3 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 3
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 決済方法：「銀行振込」を選択</p>
              <p>➋ 銀行名：利用する「銀行名」を選択</p>
              <p>➌ 支店名：「支店名」を入力</p>
              <p>➍ 支店番号：「支店コード」を入力</p>
              <p>➎ 口座名義：本人の「名義人」をカタカナで入力</p>
              <p>➏ 口座番号：「口座番号」を入力</p>
              <p>➐ 銀行番号（確認用）：「口座番号」を再入力</p>
              <p>➑ 「確認」をタップすると、登録完了</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_bank4.jpg')" alt="ステップ3">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
